module.exports = __webpack_public_path__ + "media/new-notification-022-370046.60345ba3.mp3";